import { Component } from "react";
import { connect } from "react-redux";
import StoreItemsTable from "./store-items-table";
import axios from "axios";
import urls from "../urls";
import {
  setInitialStoreItems,
  setStoreItems,
  showAddNewItemsNamesModal,
  showAddNewItemsModal,
} from "../redux-state/features/storeMgmt/storeMgmtSlice";
import SearchStore from "./searchStore";
import AddNewItemsNamesToStore from "./addNewItemsNamesToStore";
import StoreItemsSelect from "./storeItemsSelect";
import AddNewItemsToStore from "./addNewItemsToStore";
class StoreManagement extends Component {
  componentDidMount() {
    const { faculty_id } = JSON.parse(localStorage.getItem("user"));
    axios.get(urls.getStore(faculty_id)).then((res) => {
      const { pagination, results } = res.data;
      this.props.setInitialStoreItems(results);
      this.props.setStoreItems(results);
      console.log(results);
    });
  }
  render() {
    return (
      <div>
        <AddNewItemsNamesToStore />
        <AddNewItemsToStore />
        <h5 style={{ display: "flex", alignItems: "center" }}>
          المخزن
          <span
            style={{
              width: 0,
              height: 0,
              borderTop: "6px solid transparent",
              borderBottom: "6px solid transparent",
              borderRight: "10px solid black",
              marginRight: "8px",
            }}
          ></span>{" "}
        </h5>
        {/* buttons  */}
        <div className="d-flex align-items-center justify-content-between">
          <div
            className="btn-group"
            role="group"
            aria-label="Basic mixed styles example"
          >
            <button
              type="button"
              className="btn btn-success"
              onClick={() => this.props.showAddNewItemsNamesModal("supplier")}
            >
              إضافة اسماء موردين
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => this.props.showAddNewItemsNamesModal("item")}
            >
              إضافة اسماء المواد
            </button>
            <button
              type="button"
              className="btn btn-warning"
              onClick={() => this.props.showAddNewItemsModal()}
            >
              إضافة مخزون
            </button>
          </div>
          <SearchStore />
        </div>
        <hr />

        <StoreItemsTable />
      </div>
    );
  }
}

const mapDispatchToProps = {
  setInitialStoreItems,
  setStoreItems,
  showAddNewItemsModal,
  showAddNewItemsNamesModal,
};
const mapStateToProps = (state) => ({
  user: state.userState.userType,
  faculty_id: state.userState.faculty_id,
});
export default connect(mapStateToProps, mapDispatchToProps)(StoreManagement);
